import { call, put, takeEvery } from 'redux-saga/effects';
import {
  getHyperlinkByIdRequest,
  getVaultRequestByIdRequest,
  vaultCardRequest,
} from '../../utils/httpRequests';
import {
  GET_HYPERLINK_BY_ID_FAILED,
  GET_HYPERLINK_BY_ID_REQUESTED,
  GET_HYPERLINK_BY_ID_SUCCESS,
  GET_VAULT_REQUEST_BY_ID_FAILED,
  GET_VAULT_REQUEST_BY_ID_REQUESTED,
  GET_VAULT_REQUEST_BY_ID_SUCCESS,
  VAULT_CARD_REQUESTED,
  VAULT_CARD_SUCCESS,
  VAULT_CARD_FAILED,
} from '../actions/actionTypes';
import { getIdToken, getErrorData } from '../../utils/helperFunctions';

// sagas
export function* getHyperlinkByIdSaga({ payload: { uuid, locale, token } }) {
  try {
    const data = yield call(getHyperlinkByIdRequest, uuid, locale, token);
    yield put({
      type: GET_HYPERLINK_BY_ID_SUCCESS,
      payload: { data },
    });
  } catch (err) {
    yield put({
      type: GET_HYPERLINK_BY_ID_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* getVaultRequestByIdSaga({ payload: { uuid, locale } }) {
  try {
    const idToken = yield getIdToken();
    const vaultRequestData = yield call(
      getVaultRequestByIdRequest,
      uuid,
      locale,
      idToken,
    );
    yield put({
      type: GET_VAULT_REQUEST_BY_ID_SUCCESS,
      payload: { data: vaultRequestData },
    });
  } catch (err) {
    yield put({
      type: GET_VAULT_REQUEST_BY_ID_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* vaultCardSaga({ payload: { data, locale, token } }) {
  try {
    const response = yield call(vaultCardRequest, data, locale, token);
    yield put({
      type: VAULT_CARD_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    const UNKNOWN_ERROR = {
      error: {
        code: 'VPS.E.0000.00',
        type: 'Unknown',
        message: 'Unknown error',
      },
    };
    const resp = !err.response
      ? { errorResponse: { ...UNKNOWN_ERROR.error, message: err.message } }
      : {
          errorResponse: err.response?.data?.error ?? err.response?.data,
          errorData: err.response?.data?.data,
        };

    yield put({
      type: VAULT_CARD_FAILED,
      payload: { error: resp },
    });
  }
}

// watchers
export function* getHyperlinkByIdWatcher() {
  yield takeEvery(GET_HYPERLINK_BY_ID_REQUESTED, getHyperlinkByIdSaga);
}
export function* getVaultRequestByIdWatcher() {
  yield takeEvery(GET_VAULT_REQUEST_BY_ID_REQUESTED, getVaultRequestByIdSaga);
}
export function* vaultCardWatcher() {
  yield takeEvery(VAULT_CARD_REQUESTED, vaultCardSaga);
}
